module.exports = __webpack_public_path__ + "img/bubble_layout_5.0e74b3e9.svg";